import React, { Component } from "react";
import { validateToken } from "../../helpers/jwt-token-access/accessToken";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
// SweetAlert
import SweetAlert from "react-bootstrap-sweetalert";
import DatePicker from "react-datepicker";
import Select from "react-select";
import Moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
} from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { Link } from "react-router-dom";
import { BaseUrl } from "../../helpers/Baseurl";
import { toTitleCase, createSlugfromName } from "../../helpers/methods";
// Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const StatusGroup = [
  {
    label: "Itinerary Status",
    options: [
      { label: "Processing", value: "processing" },
      { label: "Under Discussion", value: "under discussion" },
      { label: "Tour Booked", value: "tour booked" },
      { label: "Tour In Progress", value: "tour in progress" },
      { label: "Tour Completed", value: "tour completed" },
    ],
  },
];

const PackegeTypeGroup = [
  {
    label: "Packege Type",
    options: [
      { label: "Budget", value: "Budget" },
      { label: "Standard", value: "Standard" },
      { label: "Deluxe", value: "Delux" },
      { label: "Premium", value: "Premium" },
      { label: "Platinum", value: "Platinum" },
    ],
  },
];

const FilterOptions = [
  {
    label: "Filter Options",
    options: [
      { label: "Name", value: "5" },
      { label: "Package Type", value: "1" },
      { label: "Status", value: "2" },
      { label: "Assigned To", value: "3" },
      { label: "Created", value: "4" },
    ],
  },
];

class Itineraries extends Component {
  constructor(props) {
    super(props);
    this.obj = JSON.parse(localStorage.getItem("authUser"));
    if (!this.obj) {
      this.props.history.push("/logout");
    } else if (!validateToken(this.obj.access)) {
      this.props.history.push("/logout");
    }
    
    // Get page from URL or localStorage
    const path = window.location.pathname;
    const pageMatch = path.match(/\/itineraries\/page\/(\d+)/);
    const urlPage = pageMatch ? parseInt(pageMatch[1], 10) : 1;
    const storedPage = localStorage.getItem("lastItineraryPage");
    
    // Use URL page as first priority, then localStorage, then default to 1
    const initialPage = urlPage > 1 ? urlPage : (storedPage ? parseInt(storedPage, 10) : 1);
    
    this.state = {
      itinerary_id: "",
      alert_confirm: false,
      success_confirm: false,
      dynamic_title: "",
      dynamic_description: "",
      itineraries: [],
      selectedStartDate: null,
      selectedendDate: null,
      page: initialPage,
      sizePerPage: 20,
      totalSize: 0,
      searchText: "",
      selectedFilterOptions: { label: "Filter By ", value: null },
      selectedPackegeType: { label: "Budget", value: "Budget" },
      selectedStatus: { label: "Processing", value: "processing" },
      selectedUser: { label: "Select User", value: null },
      filter_option: "",
      UsersGroup: [],
      breadcrumbItems: [
        { title: "Planmans", link: "/dashboard" },
        { title: "Itineraries", link: "#" },
      ],
    };
    
    toastr.options = {
      positionClass: "toast-top-right",
      closeButton: "true",
      progressBar: "true",
      showEasing: "swing",
      hideEasing: "linear",
      showMethod: "fadeIn",
      hideMethod: "fadeOut",
      showDuration: 300,
      hideDuration: 1000,
      timeOut: 5000,
      extendedTimeOut: 1000,
    };
    
    this.handleItineraryClicks = this.handleItineraryClicks.bind(this);
    this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
    this.clearFilter = this.clearFilter.bind(this);
    this.handleCopyItinerary = this.handleCopyItinerary.bind(this);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.updateUrlAndLocalStorage = this.updateUrlAndLocalStorage.bind(this);
  }

  componentDidCatch(error) {
    console.log(error);
    this.props.history.push("/dashboard");
    toastr.error("Something Went Wrong", "");
  }

  async componentDidMount() {
    // Sync URL with current page state immediately on mount
    this.updateUrlAndLocalStorage(this.state.page);
    
    // Load users and initial itinerary data
    await this.loadAllUsersData();

    // Load itineraries for the current page
    const url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&page=${this.state.page}&is_template=False`;
    await this.loadData(url, this.state.sizePerPage, this.state.page, "");

    document.title = "Itineraries | Planmans";
  }

  updateUrlAndLocalStorage(page) {
    // Update localStorage
    localStorage.setItem("lastItineraryPage", page);
    
    // Update URL without triggering page reload
    const newUrl = page === 1 ? "/itineraries" : `/itineraries/page/${page}`;
    if (window.location.pathname !== newUrl) {
      this.props.history.replace(newUrl);
    }
  }

  async loadData(url, sizePerPage, page, searchText) {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.obj.access}`,
      },
    };
    
    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();
      
      this.setState({
        itineraries: data.results,
        totalSize: data.count,
        page: page,
        sizePerPage,
        searchText,
      });
      
      // Ensure URL and localStorage are synced with the current page
      this.updateUrlAndLocalStorage(page);
    } catch (error) {
      console.log(error, "error loading itineraries data");
      toastr.error("Failed to load itineraries", "");
    }
  }

  async loadAllUsersData() {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.obj.access}`,
      },
    };
    
    try {
      const response = await fetch(`${BaseUrl}/api/accounts/users/`, requestOptions);
      const data = await response.json();
      
      let options = [];
      data.forEach((user) => {
        options.push({
          label: user.first_name + " " + user.last_name,
          value: user.email,
        });
      });
      
      let selectedUser = {
        label: options[0] ? options[0].label : "Select User",
        value: options[0] ? options[0].value : null,
      };
      
      let UsersGroup = [
        {
          label: "Users",
          options: options,
        },
      ];
      
      this.setState({ UsersGroup: UsersGroup, selectedUser });
    } catch (error) {
      console.log(error, "error loading users data");
      toastr.error("Failed to load users", "");
    }
  }

  handleFilterSubmit(e, values) {
    const {
      selectedStartDate,
      selectedendDate,
      sizePerPage,
      selectedFilterOptions,
      selectedStatus,
      selectedUser,
      selectedPackegeType,
    } = this.state;
    
    let filter_option = "";
    
    if (selectedFilterOptions.value === "1") {
      if (selectedPackegeType.value === null) {
        toastr.error("Select Package Type", "");
      } else {
        filter_option = `&packege=${selectedPackegeType.value}`;
        let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`;
        this.loadData(url, sizePerPage, 1, "");
      }
    } else if (selectedFilterOptions.value === "2") {
      if (selectedStatus.value === null) {
        toastr.error("Select Status", "");
      } else {
        filter_option = `&status=${selectedStatus.value}`;
        let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`;
        this.loadData(url, sizePerPage, 1, "");
      }
    } else if (selectedFilterOptions.value === "3") {
      if (selectedUser.value === null) {
        toastr.error("Select User", "");
      } else {
        filter_option = `&created_by__email=${selectedUser.value}`;
        let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`;
        this.loadData(url, sizePerPage, 1, "");
      }
    } else if (selectedFilterOptions.value === "4") {
      if (!selectedendDate) {
        toastr.error("Select From/To Date", "");
      } else {
        let startDate = Moment(selectedStartDate).format("YYYY-MM-DD");
        let endDate = Moment(selectedendDate).format("YYYY-MM-DD");
        filter_option = `&created__gte=${startDate}&created__lte=${endDate}T23:59:59Z`;
        let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`;
        this.loadData(url, sizePerPage, 1, "");
      }
    } else if (selectedFilterOptions.value === "5") {
      filter_option = `&search=${values.name}`;
      let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}${filter_option}`;
      this.loadData(url, sizePerPage, 1, "");
    }
    
    this.setState({ filter_option });
  }

  clearFilter() {
    let selectedFilterOptions = { label: "Filter By ", value: null };
    this.setState({
      selectedStartDate: null,
      selectedendDate: null,
      selectedFilterOptions,
      searchText: "",
      filter_option: "",
    });
    
    let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}`;
    this.loadData(url, this.state.sizePerPage, 1, "");
  }

  handleCopyItinerary(id) {
    let data = { itinerary_id: id, user_id: this.obj.user.id };
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${this.obj.access}`,
      },
      body: JSON.stringify(data),
    };
    
    fetch(`${BaseUrl}/api/itineraries/copy-added-itinerary/`, requestOptions)
      .then((res) => {
        if (res.status >= 400) {
          toastr.error("Something Went Wrong", "");
          this.setState({
            itinerary_id: "",
            copy_success_confirm: false,
            copy_alert_confirm: false,
          });
        } else {
          let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&page=${1}`;
          this.loadData(url, this.state.sizePerPage, 1, "");
          this.setState({
            itinerary_id: "",
            copy_success_confirm: true,
            copy_alert_confirm: false,
            dynamic_title: "Copied!",
            dynamic_description: "Itinerary has been Copied.",
          });
        }
      })
      .catch(error => {
        console.error("Error copying itinerary:", error);
        toastr.error("Failed to copy itinerary", "");
      });
  }

  handleItineraryClicks(id) {
    const requestOptions = {
      method: "DELETE",
      headers: { Authorization: `Bearer ${this.obj.access}` },
    };
    
    fetch(`${BaseUrl}/api/itineraries/itineraries/${id}/`, requestOptions)
      .then((res) => {
        if (res.status >= 400) {
          toastr.error("Failed to delete itinerary", "");
        } else {
          // Calculate new page number if needed
          let new_page = this.state.page;
          if (this.state.itineraries.length < 2) {
            new_page = new_page > 1 ? new_page - 1 : 1;
          }
          
          // Build URL with appropriate filters
          let url = `${BaseUrl}/api/itineraries/itineraries/?size=${this.state.sizePerPage}&page=${new_page}&is_template=False`;
          if (this.state.searchText && this.state.searchText !== "") {
            url += `&search=${this.state.searchText}`;
          }
          if (this.state.filter_option !== "") {
            url += this.state.filter_option;
          }
          
          // Load data with new page
          this.loadData(url, this.state.sizePerPage, new_page, this.state.searchText);
          
          this.setState({
            itinerary_id: "",
            success_confirm: true,
            alert_confirm: false,
            dynamic_title: "Deleted!",
            dynamic_description: "Itinerary has been deleted.",
          });
        }
      })
      .catch(error => {
        console.error("Error deleting itinerary:", error);
        toastr.error("Failed to delete itinerary", "");
      });
  }

  handleTableChange(type, { page, sizePerPage, searchText }) {
    // Immediate update of state to prevent UI lag
    this.setState({ page, sizePerPage, searchText });
    
    // Build URL with appropriate filters
    let url = `${BaseUrl}/api/itineraries/itineraries/?size=${sizePerPage}&page=${page}&is_template=False`;
    if (this.state.filter_option !== "") {
      url += this.state.filter_option;
    }
    if (searchText && searchText !== "") {
      url += `&search=${searchText}`;
    }
    
    // Load data with new page parameters
    this.loadData(url, sizePerPage, page, searchText);
  }

  render() {
    const { itineraries, sizePerPage, totalSize, page, selectedFilterOptions } =
      this.state;

    // Pagination customization
    const pageOptions = {
      page: page,
      sizePerPage: sizePerPage,
      totalSize: totalSize,
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id",
        order: "asc",
      },
    ];

    // Columns
    const itinerariesColumns = [
      {
        dataField: "id",
        text: "ID",
        sort: true,
        headerStyle: { width: "5%" },
        formatter: (cellContent, row) => `I-${row.id + 100}`,
      },
      {
        dataField: "title",
        text: "Name",
        sort: true,
        formatter: (cellContent, row) => (
          <Link
            to={`/itinerary-detail/${row.id}`}
            className="me-3 text-dark"
          >
            {(row.title).substring(0, 40)}
          </Link>
        ),
        title: (cell, row, rowIndex, colIndex) => `${cell}`,
      },
      {
        dataField: "customer_name",
        text: "Customer Name",
      },
      {
        dataField: "packege",
        text: "Package Type",
      },
      {
        dataField: "status",
        text: "Status",
        sort: true,
        formatter: (cellContent, row) => {
          return row.status === "tour completed" ? (
            <Badge
              className={"font-size-12 badge-soft-success"}
              color={"success"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          ) : row.status === "tour in progress" ? (
            <Badge
              className={"font-size-12 badge-soft-warning"}
              color={"warning"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          ) : row.status === "tour booked" ? (
            <Badge
              className={"font-size-12 badge-soft-info"}
              color={"info"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          ) : row.status === "under discussion" ? (
            <Badge
              className={"font-size-12 badge-soft-primary"}
              color={"primary"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          ) : row.status === "processing" ? (
            <Badge
              className={"font-size-12 badge-soft-primary"}
              color={"primary"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          ) : (
            <Badge
              className={"font-size-12 badge-soft-primary"}
              color={"danger"}
              pill
            >
              {toTitleCase(row.status)}
            </Badge>
          );
        },
      },
      {
        dataField: "created_by",
        text: "Assigned To",
        formatter: (cellContent, row) =>
          row.created_by.first_name
            ? row.created_by.first_name + " " + row.created_by.last_name
            : "",
      },
      {
        dataField: "created",
        text: "Created",
        sort: true,
        formatter: (cellContent, row) =>
          `${new Date(row.created).getDate()}-${new Date(row.created).getMonth() + 1}-${new Date(row.created).getFullYear()}`,
      },
      {
        dataField: "action",
        isDummyField: true,
        text: "Action",
        formatter: (cellContent, row) => {
          return this.obj.user.is_superuser ? (
            <React.Fragment>
              <a
                href={`/itinerary/${row.id}/${createSlugfromName(row.name)}`}
                className="me-3 text-primary"
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="fas fa-eye font-size-18"></i>
              </a>
              <Link
                to="#"
                onClick={() =>
                  this.setState({ copy_alert_confirm: true, itinerary_id: row.id })
                }
                className="me-3 text-secondary"
              >
                <i className="mdi mdi-content-copy font-size-18"></i>
              </Link>
              <Link
                to="#"
                onClick={() =>
                  this.setState({ alert_confirm: true, itinerary_id: row.id })
                }
                className="text-danger"
              >
                <i className="mdi mdi-trash-can font-size-18"></i>
              </Link>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <Link
                to={`/itinerary/${row.id}/${createSlugfromName(row.name)}`}
                className="me-3 text-primary"
              >
                <i className="fas fa-eye font-size-18"></i>
              </Link>
              <Link
                to="#"
                onClick={() =>
                  this.setState({ copy_alert_confirm: true, itinerary_id: row.id })
                }
                className="me-3 text-secondary"
              >
                <i className="mdi mdi-content-copy font-size-18"></i>
              </Link>
            </React.Fragment>
          );
        },
      },
    ];

    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs
              title="All Itineraries"
              breadcrumbItems={this.state.breadcrumbItems}
            />
            <Row>
              <Col xs="12">
                <Card>
                  <CardBody>
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      data={itineraries}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          data={itineraries}
                          columns={itinerariesColumns}
                          remote={{
                            filter: true,
                            pagination: true,
                            sort: true,
                            cellEdit: true,
                          }}
                          bootstrap4
                          search
                        >
                          {(toolkitProps) => (
                            <React.Fragment>
                              {/* Filter and search box */}
                              <Row className="mb-2">
                                <Col sm="9">
                                  <Row>
                                    <Col sm="2">
                                      <div
                                        className="mb-3 search-box"
                                        style={{ borderRadius: "30px" }}
                                      >
                                        <Select
                                          value={this.state.selectedFilterOptions}
                                          onChange={(e) =>
                                            this.setState({
                                              selectedFilterOptions: e,
                                            })
                                          }
                                          options={FilterOptions}
                                          classNamePrefix="select2-selection"
                                        />
                                      </div>
                                    </Col>
                                    <Col sm="10">
                                      <AvForm
                                        className="needs-validation"
                                        onValidSubmit={this.handleFilterSubmit}
                                      >
                                        <Row>
                                          <Col sm="12">
                                            {selectedFilterOptions.value ? (
                                              <Row>
                                                {selectedFilterOptions.value ===
                                                "1" ? (
                                                  <Col sm="6">
                                                    <div
                                                      className="mb-3 search-box"
                                                    >
                                                      <Select
                                                        value={
                                                          this.state
                                                            .selectedPackegeType
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            selectedPackegeType: e,
                                                          })
                                                        }
                                                        options={PackegeTypeGroup}
                                                        classNamePrefix="select2-selection"
                                                      />
                                                    </div>
                                                  </Col>
                                                ) : selectedFilterOptions.value ===
                                                  "2" ? (
                                                  <Col sm="6">
                                                    <div className="mb-3 ">
                                                      <Select
                                                        value={
                                                          this.state.selectedStatus
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            selectedStatus: e,
                                                          })
                                                        }
                                                        options={StatusGroup}
                                                        classNamePrefix="select2-selection"
                                                      />
                                                    </div>
                                                  </Col>
                                                ) : selectedFilterOptions.value ===
                                                  "3" ? (
                                                  <Col sm="6">
                                                    <div
                                                      className="search-box mb-3 "
                                                    >
                                                      <Select
                                                        value={
                                                          this.state.selectedUser
                                                        }
                                                        onChange={(e) =>
                                                          this.setState({
                                                            selectedUser: e,
                                                          })
                                                        }
                                                        options={
                                                          this.state.UsersGroup
                                                        }
                                                        classNamePrefix="select2-selection"
                                                      />
                                                    </div>
                                                  </Col>
                                                ) : selectedFilterOptions.value ===
                                                  "4" ? (
                                                  <Col md="6">
                                                    <Row>
                                                      <Col md="6">
                                                        <div
                                                          className="search-box mb-3"
                                                        >
                                                          <DatePicker
                                                            className="form-control"
                                                            selected={
                                                              this.state
                                                                .selectedStartDate
                                                            }
                                                            onChange={(date) =>
                                                              this.setState({
                                                                selectedStartDate:
                                                                  date,
                                                              })
                                                            }
                                                            selectsStart
                                                            startDate={
                                                              new Date()
                                                            }
                                                            maxDate={new Date()}
                                                            placeholderText="From Date"
                                                            isClearable={true}
                                                          />
                                                        </div>
                                                      </Col>
                                                      <Col md="6">
                                                        <div
                                                          className="search-box mb-3"
                                                        >
                                                          <DatePicker
                                                            className="form-control"
                                                            selected={
                                                              this.state
                                                                .selectedendDate
                                                            }
                                                            onChange={(date) =>
                                                              this.setState({
                                                                selectedendDate:
                                                                  date,
                                                              })
                                                            }
                                                            selectsEnd
                                                            startDate={
                                                              this.state
                                                                .selectedStartDate
                                                            }
                                                            minDate={
                                                              this.state
                                                                .selectedStartDate
                                                            }
                                                            maxDate={new Date()}
                                                            placeholderText="To Date"
                                                            isClearable={true}
                                                          />
                                                        </div>
                                                      </Col>
                                                    </Row>
                                                  </Col>
                                                ) : selectedFilterOptions.value ===
                                                  "5" ? (
                                                  <Col md="6">
                                                    <div
                                                      className="search-box mb-3"
                                                    >
                                                      <div className="position-relative">
                                                        <AvField
                                                          name="name"
                                                          placeholder={"Name"}
                                                          type="text"
                                                          errorMessage={
                                                            "Enter Name"
                                                          }
                                                          className="form-control"
                                                          validate={{
                                                            required: {
                                                              value: true,
                                                            },
                                                          }}
                                                          id="name"
                                                        />
                                                      </div>
                                                    </div>
                                                  </Col>
                                                ) : null}
                                                <Col md="4">
                                                  <div className="mb-2">
                                                    <Button
                                                      type="submit"
                                                      color="primary"
                                                      className="btn-rounded me-1"
                                                    >
                                                      <i className="mdi mdi-filter-outline me-1" />
                                                      Apply Filter
                                                    </Button>{" "}
                                                    {this.state.filter_option !==
                                                    "" ? (
                                                      <Button
                                                        type="button"
                                                        color="secondary"
                                                        onClick={this.clearFilter}
                                                        className="btn-rounded me-1"
                                                      >
                                                        <i className="mdi mdi-close me-1" />{" "}
                                                        Clear
                                                      </Button>
                                                    ) : null}
                                                  </div>
                                                </Col>
                                              </Row>
                                            ) : null}
                                          </Col>
                                        </Row>
                                      </AvForm>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col sm="3">
                                  <div className="text-sm-end">
                                    <Button
                                      type="button"
                                      color="success"
                                      className="btn-rounded mb-2 me-2"
                                      onClick={() =>
                                        this.props.history.push("/new-itinerary")
                                      }
                                    >
                                      <i className="mdi mdi-plus me-1" /> Add
                                      Itinerary
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              {/* End Filter and search box */}
                              <div className="table-responsive">
                                <BootstrapTable
                                  remote
                                  {...toolkitProps.baseProps}
                                  {...paginationTableProps}
                                  responsive
                                  bordered={false}
                                  striped={true}
                                  defaultSorted={defaultSorted}
                                  headerWrapperClasses={"table-light"}
                                  columns={itinerariesColumns}
                                  onTableChange={this.handleTableChange}
                                  hoverclasses={
                                    "table align-middle table-nowrap"
                                  }
                                />
                              </div>
                              <div className="pagination pagination-rounded justify-content-end mb-2">
                                <PaginationListStandalone
                                  {...paginationProps}
                                />
                              </div>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  </CardBody>
                </Card>
              </Col>
              {this.state.alert_confirm ? (
                <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() =>
                    this.handleItineraryClicks(this.state.itinerary_id)
                  }
                  onCancel={() =>
                    this.setState({
                      alert_confirm: false,
                      itinerary_id: "",
                    })
                  }
                >
                  You won't be able to revert this!
                </SweetAlert>
              ) : null}
              {this.state.success_confirm ? (
                <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() =>
                    this.setState({
                      success_confirm: false,
                      alert_confirm: false,
                    })
                  }
                >
                  {this.state.dynamic_description}
                </SweetAlert>
              ) : null}
              {this.state.copy_alert_confirm ? (
                <SweetAlert
                  title="Are you sure?"
                  warning
                  showCancel
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() =>
                    this.handleCopyItinerary(this.state.itinerary_id)
                  }
                  onCancel={() =>
                    this.setState({
                      copy_alert_confirm: false,
                      itinerary_id: "",
                    })
                  }
                >
                  You Really Want to replicate it !
                </SweetAlert>
              ) : null}
              {this.state.copy_success_confirm ? (
                <SweetAlert
                  success
                  title={this.state.dynamic_title}
                  confirmBtnBsStyle="success"
                  cancelBtnBsStyle="danger"
                  onConfirm={() =>
                    this.setState({
                      copy_success_confirm: false,
                      copy_alert_confirm: false,
                    })
                  }
                >
                  {this.state.dynamic_description}
                </SweetAlert>
              ) : null}
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default Itineraries;